import React, { useEffect, useState, useContext, useRef, useMemo } from "react";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { AccountContext } from "context/account";

import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";

import AddResourceModal from "pages/online-resource/components/AddResourceModal";
import FlatDrawingCard from "pages/online-resource/components/FlatDrawingCard";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { resourceCategoryOptions, resourceDetailSketchOptions } from "utils/data";
import { Empty, Tabs as AntTabs } from "antd";
import Badge from "@mui/material/Badge";

const FlatSketches = ({ sharedView = false }) => {
  const [categoryTabs, setCategoryTabs] = useState(resourceCategoryOptions[0].value);
  const [resourceList, setResourceList] = useState([]);

  const [createVisible, setCreateVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  const [detailTab, setDetailTab] = useState(resourceDetailSketchOptions[0].value);

  const account = useContext(AccountContext);

  useEffect(() => {
    if (account.id) {
      handleRefresh();
    }
  }, [account.id, categoryTabs]);

  const handleRefresh = async () => {
    try {
      const { data } = await api.onlineResource.list({ category: categoryTabs });
      setResourceList(data?.online_resources || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteResource = async () => {
    try {
      await api.onlineResource.delete(selectedResource.id);
      handleRefresh();
      setDeleteVisible(false);
      toast.success(`Delete resource ${selectedResource?.title} successfully!`);
    } catch (err) {
      toast.error(`Failed to delete resource ${selectedResource?.title}!`);

      console.log(err);
    }
  };

  const handleChangeTab = (e, newValue) => {
    setCategoryTabs(newValue);
  };

  const handleChangeDetailTab = (newValue) => {
    setDetailTab(newValue);
  };

  return (
    <SuiBox my={1}>
      <Card sx={{ p: 3 }}>
        {account?.role == "admin" ? (
          <SuiBox display="flex" alignItems="center" justifyContent="space-between" sx={{ gap: 1 }}>
            <SuiTypography variant="h5">Flat Sketches</SuiTypography>
            <SuiButton
              variant="gradient"
              color="dark"
              onClick={() => setCreateVisible(true)}
              size="small"
            >
              +Add Resource
            </SuiButton>
          </SuiBox>
        ) : null}
        <SuiBox display="flex" justifyContent="center" width="100%" mb={1}>
          <SuiBox my={1} mx={2}>
            <Tabs value={categoryTabs} onChange={handleChangeTab} aria-label="basic tabs example">
              {resourceCategoryOptions.map((item, index) => (
                <Tab
                  label={
                    item.value == "detail" ? (
                      <Badge
                        badgeContent={
                          <SuiTypography
                            variant="body2"
                            color="white"
                            sx={{ fontSize: 10, fontWeight: "bold" }}
                          >
                            New
                          </SuiTypography>
                        }
                        color="error"
                        variant="string"
                      >
                        Detail
                      </Badge>
                    ) : (
                      item.label
                    )
                  }
                  value={item.value}
                  sx={{ px: 3, py: 1 }}
                />
              ))}
            </Tabs>
          </SuiBox>
        </SuiBox>
        {resourceList.length > 0 || account?.role == "admin" ? (
          categoryTabs == "detail" ? (
            <AntTabs
              tabPosition={"left"}
              items={resourceDetailSketchOptions.map((item, index) => {
                return {
                  label: item.label,
                  key: item.value,
                  children: (
                    <ResponsiveMasonry
                      columnsCountBreakPoints={{ 300: 1, 550: 2, 850: 3, 1200: 4, 1400: 5 }}
                    >
                      <Masonry gutter="16px">
                        {resourceList
                          .filter((x) => x?.metadata?.subcategory == item.value)
                          .map((item) => (
                            <FlatDrawingCard resource={item} handleRefresh={handleRefresh} />
                          ))}
                        {account?.role == "admin" ? (
                          <SuiBox
                            sx={{
                              width: "100%",
                              height: 254,
                              border: "1px dashed gray",
                              cursor: "pointer",
                            }}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            onClick={() => setCreateVisible(true)}
                          >
                            <SuiTypography variant="h5">+ Add</SuiTypography>
                          </SuiBox>
                        ) : null}
                      </Masonry>
                    </ResponsiveMasonry>
                  ),
                };
              })}
              onChange={handleChangeDetailTab}
            />
          ) : (
            <ResponsiveMasonry
              columnsCountBreakPoints={{ 300: 1, 550: 2, 850: 3, 1200: 4, 1400: 5 }}
            >
              <Masonry gutter="16px">
                {resourceList.map((item) => (
                  <FlatDrawingCard resource={item} handleRefresh={handleRefresh} />
                ))}
                {account?.role == "admin" ? (
                  <SuiBox
                    sx={{
                      width: "100%",
                      height: 254,
                      border: "1px dashed gray",
                      cursor: "pointer",
                    }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onClick={() => setCreateVisible(true)}
                  >
                    <SuiTypography variant="h5">+ Add</SuiTypography>
                  </SuiBox>
                ) : null}
              </Masonry>
            </ResponsiveMasonry>
          )
        ) : (
          <SuiBox my={2}>
            <Empty />
          </SuiBox>
        )}
      </Card>

      {createVisible ? (
        <AddResourceModal
          visible={createVisible}
          handleClose={() => setCreateVisible(false)}
          type={"flat_sketch"}
          handleRefresh={handleRefresh}
          defaultCategory={categoryTabs}
          defaultSubCategory={detailTab}
        />
      ) : null}
      {editVisible ? (
        <AddResourceModal
          visible={editVisible}
          handleClose={() => setEditVisible(false)}
          type={"flat_sketch"}
          isEdit={true}
          resource={selectedResource}
          handleRefresh={handleRefresh}
        />
      ) : null}

      {deleteVisible && selectedResource ? (
        <Prompt
          heading="Delete Resource"
          text={`Are you sure you want to delete: ${selectedResource.title}`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={() => handleDeleteResource(selectedResource)}
          handleClose={() => setDeleteVisible(false)}
        />
      ) : null}
    </SuiBox>
  );
};

export default FlatSketches;
